import { useTheme } from '@/shared/ui/mui';
import type { Audience } from './useAudienceToggle';

export interface AudienceColorPalette {
  main: string;
  dark: string;
  light: string;
  lighter: string;
  ultraLight: string;
  accent: string;
}

export const useAudienceColors = (audience: Audience): AudienceColorPalette => {
  const theme = useTheme();
  if (audience === 'providers') {
    return {
      main: theme.palette.red.main,
      dark: theme.palette.red.dark,
      light: theme.palette.red.light,
      lighter: theme.palette.red.light,
      ultraLight: theme.palette.red.ultraLight,
      accent: theme.palette.red.accent,
    };
  }
  return {
    main: theme.palette.primary.main,
    dark: theme.palette.primary.dark,
    light: theme.palette.primary.light,
    lighter: theme.palette.primary.lighter,
    ultraLight: theme.palette.primary.ultraLight,
    accent: theme.palette.primary.accent,
  };
};
